import { CreateRequirementDefinitionRequest } from "@wingspanhq/wingspan-api-sdk";

import {
  convertFormApprovalDataToReviewStrategy,
  convertFormDataToExpirationStrategy
} from "../components/CreateRequirementDefinitionForm/utils";
import { BaseRequirementDefinitionFormValues } from "../types";

export const baseMapFormDataToRequirementCreateRequest = (
  formData: BaseRequirementDefinitionFormValues
): Omit<CreateRequirementDefinitionRequest, "dataSourceId"> => {
  return {
    description: formData.description,
    name: formData.name,
    type: formData.type,
    reviewPolicy: convertFormApprovalDataToReviewStrategy(formData),
    ...convertFormDataToExpirationStrategy(formData)
  };
};
